// extracted by mini-css-extract-plugin
export default {"tags":"tags-J0JZ"};